
























import Vue from "vue";
// import { apiUrl } from "@/domain";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "automationsJobsModal",
  data() {
    return {
      columns: [
        {
          label: "Name",
          field: "name",
          width: "150px",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Type",
          field: "type",
        },
        {
          label: "Automation Id",
          field: "automation_id",
        },
        {
          label: "From Date",
          field: "from_date",
        },
        {
          label: "Org ids",
          field: "organization_ids",
        },
        {
          label: "Done Org ids",
          field: "completed_organization_ids",
        },
        {
          label: "Error",
          field: "error_message",
        },
        {
          label: "Updated at",
          field: "updated_at",
          width: "140px",
        },
        {
          label: "Created at",
          field: "created_at",
          width: "140px",
        },
      ],
      options: [
        { label: "ALL", value: null },
        { label: "PENDING", value: "PENDING" },
        { label: "IN_PROGRESS", value: "IN_PROGRESS" },
        { label: "COMPLETED", value: "COMPLETED" },
        { label: "ERROR", value: "ERROR" },
      ],
      rows: [],
      statusFilter: null,
    };
  },
  components: {
    HeaderComponent,
  },
  props: {
    id: Number,
    new: Boolean,
  },
  computed: {
    filteredRows() {
      return this.rows.filter((itm) => {
        if (!this.statusFilter) {
          return itm;
        } else {
          return itm.status == this.statusFilter;
        }
      });
    },
  },
  methods: {
    loadJobs() {
      ApiService.sadminApi.getAutomationJobs().then((resp) => {
        this.rows = resp.data;
      });
    },
  },
  mounted() {
    this.loadJobs();
  },
});
